import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import defaultImage from "../../../assets/images/default.jpg";
import { getFullImageUrl } from "../../extra/ImageSet";
import { CLOSE_DIALOGUE } from "../../store/dialogue/dialogue.type";
import { getSetting } from "../../store/setting/setting.action";

const FakeReelInformation = () => {
    const dispatch = useDispatch();
    const { dialogueData } = useSelector((state) => state.dialogue);

    const { setting } = useSelector((state) => state.setting);

    useEffect(() => {
        dispatch(getSetting());
    }, [dispatch]);

    // Format date function
    const formatDate = (dateString) => {
        if (!dateString) return "N/A";
        const date = new Date(dateString);
        return date.toLocaleDateString("en-US", {
            year: "numeric",
            month: "long",
            day: "numeric",
            hour: "2-digit",
            minute: "2-digit",
        });
    };

    return (
        <div className="mainDialogue fade-in" style={{ maxHeight: '100vh', overflowY: 'auto' }}>
            <div className="DialogueFakeReels" style={{ maxHeight: '100vh', overflowY: 'auto' }}>
                {/* Header */}
                <div className="dialogueHeader">
                    <div className="headerTitle fw-bold">Fake Reel Information</div>
                    <div
                        className="closeBtn"
                        onClick={() => {
                            dispatch({ type: CLOSE_DIALOGUE });
                        }}
                    >
                        <i className="fa-solid fa-xmark"></i>
                    </div>
                </div>

                <div className="row g-3" style={{ padding: "20px 24px" }}>
                    {/* Left Section - Main Image */}
                    <div className="col-12 col-md-5">
                        <div className="d-flex justify-content-start">
                            <img
                                src={getFullImageUrl(dialogueData?.mainImage) || defaultImage}
                                alt="Fake Reel"
                                className="w-100"
                                style={{
                                    borderRadius: "8px",
                                    objectFit: "cover",
                                    height: "520px",
                                    backgroundColor: "#f8f9fa",
                                    objectPosition: 'top'
                                }}
                                crossOrigin="anonymous"
                                onError={(e) => {
                                    e.target.onerror = null;
                                    e.target.src = defaultImage;
                                }}
                            />
                        </div>
                    </div>

                    {/* Right Section - Product Details */}
                    <div className="col-12 col-md-7">
                        {/* Date */}
                        {/* <div className="mb-3">
                            <p style={{ color: "#6c757d", fontSize: "14px" }}>
                                Product Details
                            </p>
                        </div> */}

                        {/* Scrollable Section for Details */}
                        <div
                            style={{
                                maxHeight: "500px",
                                overflowY: "auto",
                                paddingRight: "12px",
                            }}
                        >
                            {/* Product Information Card */}
                            {dialogueData && (
                                <div
                                    className="mb-4"
                                    style={{
                                        border: "1px solid #eee",
                                        borderRadius: "8px",
                                        padding: "18px",
                                        background: "#fff",
                                    }}
                                >
                                    <h5
                                        className="fw-semibold mb-3"
                                        style={{ color: "#b93160" }}
                                    >
                                        <i className="fa-solid fa-box me-2"></i>
                                        Product Details
                                    </h5>

                                    <div className="d-flex flex-column">
                                        <div className="d-flex mb-3">
                                            {/* <div style={{ minWidth: "100px", marginRight: "15px" }}>
                                                <img
                                                    src={
                                                        getFullImageUrl(dialogueData?.mainImage) ||
                                                        defaultImage
                                                    }
                                                    alt={dialogueData?.productName || "Product"}
                                                    style={{
                                                        width: "150px",
                                                        borderRadius: "6px",
                                                        objectFit: "cover",
                                                        height: "195px",
                                                    }}
                                                    crossOrigin="anonymous"
                                                    onError={(e) => {
                                                        e.target.onerror = null;
                                                        e.target.src = defaultImage;
                                                    }}
                                                />
                                            </div> */}

                                            <div style={{ flex: 1 }}>
                                                {dialogueData?.productName && (
                                                    <div
                                                        className="fw-semibold mb-2"
                                                        style={{ color: "#000" }}
                                                    >
                                                        Product Name:{" "}
                                                        <span
                                                            style={{ color: "#495057", fontWeight: "400" }}
                                                        >
                                                            {dialogueData?.productName}
                                                        </span>
                                                    </div>
                                                )}

                                                {dialogueData?.productCode && (
                                                    <div
                                                        className="fw-semibold mb-2"
                                                        style={{ color: "#000" }}
                                                    >
                                                        Product Code:{" "}
                                                        <span
                                                            style={{ color: "#495057", fontWeight: "400" }}
                                                        >
                                                            {dialogueData?.productCode}
                                                        </span>
                                                    </div>
                                                )}

                                                {dialogueData?.price && (
                                                    <div
                                                        className="fw-semibold mb-2"
                                                        style={{ color: "#000" }}
                                                    >
                                                        Price ({setting?.currency?.symbol}):{" "}
                                                        <span
                                                            style={{ color: "#28a745", fontWeight: "600" }}
                                                        >
                                                            {dialogueData?.price}
                                                        </span>
                                                    </div>
                                                )}

                                                {dialogueData?.shippingCharges && (
                                                    <div
                                                        className="fw-semibold mb-2"
                                                        style={{ color: "#000" }}
                                                    >
                                                        Shipping Charges:{" "}
                                                        <span
                                                            style={{ color: "#495057", fontWeight: "400" }}
                                                        >
                                                            {setting?.currency?.symbol}{" "}
                                                            {dialogueData?.shippingCharges}
                                                        </span>
                                                    </div>
                                                )}

                                                {/* {dialogueData?.createStatus && (
                                                    <div
                                                        className="fw-semibold mb-2"
                                                        style={{ color: "#000" }}
                                                    >
                                                        Status:{" "}
                                                        <span
                                                            style={{ 
                                                                color: dialogueData?.createStatus === "Approved" ? "#28a745" : "#ffc107", 
                                                                fontWeight: "600" 
                                                            }}
                                                        >
                                                            {dialogueData?.createStatus}
                                                        </span>
                                                    </div>
                                                )} */}
                                            </div>
                                        </div>

                                        {/* Attributes Section */}
                                        {dialogueData?.attributes && dialogueData.attributes.length > 0 && (
                                            <div className="mb-2">
                                                <div className="fw-semibold mb-2" style={{ color: "#000" }}>
                                                    Attributes:
                                                </div>
                                                <div style={{ marginTop: "8px" }}>
                                                    {/* {dialogueData.attributes.map((attr, attrIndex) => (
                                                        <div
                                                            key={attrIndex}
                                                            className="mb-2"
                                                            style={{
                                                                padding: "8px 12px",
                                                                backgroundColor: "#f8f9fa",
                                                                borderRadius: "6px",
                                                                border: "1px solid #e9ecef"
                                                            }}
                                                        >
                                                            <div style={{ color: "#495057" }}>
                                                                <span className="fw-semibold" style={{ color: "#b93160" }}>
                                                                    {attr.name}:
                                                                </span>{" "}
                                                                {attr.values && attr.values.length > 0 ? (
                                                                    <span style={{ display: "inline-flex", flexWrap: "wrap", gap: "6px", marginLeft: "8px" }}>
                                                                        {attr.values.map((value, valueIndex) => (
                                                                            <span
                                                                                key={valueIndex}
                                                                                style={{
                                                                                    padding: "4px 10px",
                                                                                    backgroundColor: "#fff",
                                                                                    border: "1px solid #dee2e6",
                                                                                    borderRadius: "4px",
                                                                                    fontSize: "13px",
                                                                                    color: "#495057"
                                                                                }}
                                                                            >
                                                                                {value}
                                                                            </span>
                                                                        ))}
                                                                    </span>
                                                                ) : (
                                                                    <span style={{ color: "#6c757d", fontStyle: "italic" }}>
                                                                        No values available
                                                                    </span>
                                                                )}
                                                            </div>
                                                        </div>
                                                    ))} */}
                                                    {dialogueData.attributes.map((attr, attrIdx) => (
                                                        <div key={attrIdx} style={{ marginBottom: "8px", marginLeft: "12px" }}>
                                                            {/* Attribute Image */}
                                                            {attr?.image && (
                                                                <img
                                                                    src={getFullImageUrl(attr.image)}
                                                                    alt={attr.name}
                                                                    crossOrigin='anonymous'
                                                                    style={{ width: "40px", height: "40px", objectFit: "cover", borderRadius: "4px", marginRight: "10px" }}
                                                                    onError={(e) => {
                                                                        e.target.onerror = null;
                                                                        e.target.src = defaultImage;
                                                                    }}
                                                                />
                                                            )}
                                                            {/* Attribute Name + Values */}
                                                            <span style={{ color: "#444", fontWeight: "bold" }}>{attr?.name}:</span>
                                                            <span style={{ marginLeft: "8px" }}>
                                                                {(attr?.values || []).join(", ")}
                                                            </span>
                                                        </div>
                                                    ))}
                                                </div>
                                            </div>
                                        )}
                                    </div>
                                </div>
                            )}

                            {/* Seller Information Card */}
                            {/* {dialogueData?.seller && (
                                <div
                                    className="mb-4"
                                    style={{
                                        border: "1px solid #eee",
                                        borderRadius: "8px",
                                        padding: "18px",
                                        background: "#fff",
                                    }}
                                >
                                    <h5 className="fw-semibold mb-3" style={{ color: "#b93160" }}>
                                        <i className="fa-solid fa-user me-2"></i>
                                        Seller Details
                                    </h5>

                                    <div className="d-flex align-items-center mb-3">
                                        <img
                                            src={
                                                getFullImageUrl(dialogueData?.seller?.image) ||
                                                defaultImage
                                            }
                                            alt="Seller"
                                            style={{
                                                width: "60px",
                                                height: "60px",
                                                borderRadius: "50%",
                                                objectFit: "cover",
                                                marginRight: "15px",
                                            }}
                                            crossOrigin="anonymous"
                                            onError={(e) => {
                                                e.target.onerror = null;
                                                e.target.src = defaultImage;
                                            }}
                                        />
                                        <div>
                                            <p className="fw-bold mb-0" style={{ fontSize: "16px" }}>
                                                Seller ID: {dialogueData?.seller}
                                            </p>
                                        </div>
                                    </div>
                                </div>
                            )} */}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default FakeReelInformation;
